import React, { useContext } from "react";
// parcelles actives context
import { ParcellesContext } from "parcelles/provider";
// react-bootstrap components
import { ListGroup, Badge } from "react-bootstrap";

// Bandeau affichant le nombre de parcelles sélectionnées, la surface totale
// et la liste des parcelles sous forme de badges. Les données sont lues
// directement depuis ParcellesContext, donc aucune prop n'est nécessaire.
const BandeauParcellesActives = ({ children }) => {
  const { parcellesActives, getSurfaceTotale } = useContext(ParcellesContext);

  return (
    <ListGroup className="w-100">
      <ListGroup.Item variant="success" style={{ minHeight: "80px" }}>
        <div className="d-flex justify-content-between">
          <h6>{parcellesActives.length} parcelle(s)</h6>
          <h6>Surface totale : {getSurfaceTotale()} ha</h6>
        </div>
        <div className="d-flex flex-wrap">
          {parcellesActives.map((parcelle) => (
            <Badge key={parcelle.id} variant="success" className="mr-2 mt-2">
              {parcelle.label}
            </Badge>
          ))}
        </div>
        {children}
      </ListGroup.Item>
    </ListGroup>
  );
};

export default BandeauParcellesActives;
